(function () {


    angular
        .module('invesfleet')
        .config([
            '$urlRouterProvider',
            '$httpProvider',
            '$stateProvider',
            '$qProvider',
            config
        ]);

    function config($urlRouterProvider, $httpProvider, $stateProvider, $qProvider) {

        $qProvider.errorOnUnhandledRejections(false);

        $stateProvider
            //Login
            .state('login', {
                url: '/login',
                controller: 'LoginController',
                controllerAs: 'vm',
                templateUrl: 'app/views/login/default.html',
                params: {
                    loading: false,
                    // redirectState: 'flota.mapa', //byArnau
                    redirectState: 'flota.misfichajes',
                    redirectParams: null,
                }
            })

            // //Mapa
            // .state('flota.mapa', {
            //     url: '/mapa?id&lat&long',
            //     data: { tabTitle: 'Mapa', tabView: 'flotaMapa', icon: 'icon-010', fixed: true, open: true, sidebar: true },
            //     sticky: true,
            //     deepStateRedirect: true,
            //     views: {
            //         'flotaMapa': {
            //             controller: 'MapController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/mapa/default.html'
            //         }
            //     }
            // })

            //Contenedor
            .state('flota', {
                controller: 'MainController',
                controllerAs: 'vm',
                url: '/flota',
                templateUrl: 'app/views/common/content.html'
            })

            //404
            .state('flota.404', {
                url: '/404',
                data: {
                    tabTitle: 'Página no encontrada',
                    tabView: 'Error404',
                    icon: 'icon-071'
                },
                sticky: true,
                deepStateRedirect: true,
                views: {
                    'Error404': {
                        templateUrl: 'app/views/flota/404/default.html'
                    }
                }
            })

             //Informes
             .state('flota.informes', {
                     url: '/informes',
                     sticky: true,
                     abstract: true,
                     views: {
                         'informes': {
                             template: '<div ui-view="informesContainer"/>'
                         }
                     }
                 })

                 //Informes - Listado informes
                 .state('flota.informes.listado', {
                     url: '/listado',
                     data: {
                         tabTitle: 'Informes',
                         tabView: 'informes',
                         icon: 'icon-094'
                     },
                     views: {
                         'informesContainer': {
                             controller: 'InformeListController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/informes/default.html'
                         }
                     }
                 })

                 //Informes - Nuevo informe
                 .state('flota.informes.nuevoInforme', {
                     url: '/nuevo',
                     data: {
                         tabTitle: 'Informes',
                         tabView: 'informes',
                         icon: 'icon-094'
                     },
                     views: {
                         'informesContainer': {
                             controller: 'InformeNuevoController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/informes/nuevoInforme.html'
                         }
                     }
                 })

                 //Informes - Editar informe
                 .state('flota.informes.editarInforme', {
                     url: '/editar?id',
                     data: {
                         tabTitle: 'Informes',
                         tabView: 'informes',
                         icon: 'icon-094'
                     },
                     views: {
                         'informesContainer': {
                             controller: 'InformeNuevoController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/informes/nuevoInforme.html'
                         }
                     }
                 })

                 //Informes - Detalle informe
                 .state('flota.informes.detalle', {
                     url: '/detalle?id',
                     data: {
                         tabTitle: 'Detalle informe',
                         tabView: 'informes',
                         icon: 'icon-094'
                     },
                     views: {
                         'informesContainer': {
                             controller: 'InformeFormController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/informes/detalle_informe.html'
                         }
                     }
                 })

                 //Informes - nopremium quitar
                 .state('flota.informes.nopremium', {
                     url: '/nopremium?id',
                     data: {
                         tabTitle: 'nopremium informe',
                         tabView: 'informes',
                         icon: 'icon-094'
                     },
                     views: {
                         'informesContainer': {
                             controller: 'InformeNoPremiumController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/informes/nopremium.html'
                         }
                     }
                 })

                 //Control horario
                 .state('flota.controlHorario', {
                     url: '/controlHorario',
                     sticky: true,
                     abstract: true,
                     views: {
                         'controlHorario': {
                             template: '<div ui-view="horarioContainer"/>'
                         }
                     }
                 })

                .state('flota.misfichajes', {
                    url: '/misfichajes?tabNumber',
                    sticky: true,
                    deepStateRedirect: true,
                    data: {
                        tabTitle: 'Mis fichajes',
                        tabView: 'misfichajes',
                        icon: 'icon-050'
                    },
                    params: {
                        //programadas: true
                    },
                    views: {
                        'misfichajes': {
                            controller: 'misfichajesController',
                            controllerAs: 'vm',
                            templateUrl: 'app/views/flota/controlHorario/misfichajes.html'
                        }
                    }
                })


                 //Control horario - Fichajes
                 .state('flota.controlHorario.fichajes', {
                     url: '/fichajes?tabNumber&empleadoId',
                     data: {
                         tabTitle: 'Fichajes',
                         tabView: 'controlHorario',
                         icon: 'icon-050'
                     },
                     views: {
                         'horarioContainer': {
                             controller: 'fichajesController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/controlHorario/fichajes.html'
                         }
                     }
                 })

            

                 //Control horario - detalleJornada
                 .state('flota.controlHorario.detalleJornada', {
                     url: '/detalleJornada?id&type&tabNumber&empleadoId',
                     data: {
                         tabTitle: 'Detalle jornada',
                         tabView: 'controlHorario',
                         icon: 'icon-050'
                     },
                     views: {
                         'horarioContainer': {
                             controller: 'detalleJornadaController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/controlHorario/detalleJornada.html'
                         }
                     }
                 })

                     //  //Control horario - guardias
                     //  .state('flota.guardias', {
                     //      url: '/guardias?tabNumber',
                     //      data: {
                     //          tabTitle: 'Guardias',
                     //          tabView: 'guardias',
                     //          icon: 'icon-050'
                     //      },
                     //      views: {
                     //          'guardias': {
                     //              controller: 'disponibilidadController',
                     //              controllerAs: 'vm',
                     //              templateUrl: 'app/views/flota/controlHorario/disponibilidad.html'
                     //          }
                     //      }
                     //  })

                 //Control horario - detalleMiJornada
                 .state('flota.controlHorario.detalleMiJornada', {
                     url: '/detalleMiJornada?id&tabNumber',
                     data: {
                         tabTitle: 'Detalle jornada',
                         tabView: 'controlHorario',
                         icon: 'icon-050'
                     },
                     views: {
                         'horarioContainer': {
                             controller: 'detalleMiJornadaController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/controlHorario/detalleMiJornada.html'
                         }
                     }
                 })

                 //Control horario - ActivarControlHorario
                 .state('flota.controlHorario.activarControlHorario', {
                     url: '/activarControlHorario',
                     data: {
                         tabTitle: 'Activar control horario',
                         tabView: 'controlHorario',
                         icon: 'icon-050'
                     },
                     views: {
                         'horarioContainer': {
                             controller: 'activarControlHorarioController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/controlHorario/activarControlHorario.html'
                         }
                     }
                 })


                 //Suscripciones

            //Control horario - Empleados
            .state('flota.empleados', {
                url: '/empleados',
                data: { tabTitle: 'Empleados', tabView: 'empleados', icon: 'icon-050' },
                views: {
                    'empleados': {
                        controller: 'empleadosController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/controlHorario/empleados.html'
                    }
                }
            })

            //Control horario - Editar empleado
            .state('flota.editarEmpleado', {
                url: '/editarEmpleado?id',
                data: { tabTitle: 'Editar empleado', tabView: 'editarEmpleado', icon: 'icon-050' },
                views: {
                    'editarEmpleado': {
                        controller: 'editarEmpleadoController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/controlHorario/nuevoEmpleado.html'
                    }
                }
            })


                 .state('flota.suscripciones', {
                     url: '/suscripciones',
                     sticky: true,
                     abstract: true,
                     views: {
                         'suscripciones': {
                             template: '<div ui-view="suscripcionesContainer"/>'
                         }
                     }
                 })

                 //Suscripciones general
                 .state('flota.suscripciones.general', {
                     url: '/general',
                     data: {
                         tabTitle: 'Suscripciones',
                         tabView: 'suscripciones',
                         icon: 'icon-019'
                     },
                     views: {
                         'suscripcionesContainer': {
                             controller: 'controlSusController',
                             controllerAs: 'vm',
                             templateUrl: 'app/views/flota/suscripciones/default.html'
                         }
                     }
                 })


            

            //Actividad - Órdenes activas
            .state('flota.OrdenesActivas', {
                url: '/ordenes_activas',
                sticky: true,
                deepStateRedirect: true,
                data: { tabTitle: 'Órdenes activas', tabView: 'OrdenesActivas', icon: 'icon-004' },
                views: {
                    'OrdenesActivas': {
                        controller: 'ActiveOrdersController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/actividad/ordenes_activas.html'
                    }
                }
            })

            //Actividad - Actividad flota
            .state('flota.ActividadFlota', {
                url: '/actividad_flota',
                sticky: true,
                deepStateRedirect: true,
                data: { tabTitle: 'Actividad de la flota', tabView: 'ActividadFlota', icon: 'icon-018' },
                views: {
                    'ActividadFlota': {
                        controller: 'ActivityFleetController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/actividad/actividad_flota.html'
                    }
                }
            })

            //Actividad - Actividad chóferes
            .state('flota.ActividadChoferes', {
                url: '/actividad_choferes',
                sticky: true,
                deepStateRedirect: true,
                data: { tabTitle: 'Actividad de los chóferes', tabView: 'ActividadChoferes', icon: 'icon-018' },
                views: {
                    'ActividadChoferes': {
                        controller: 'ActivityDriverController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/actividad/actividad_choferes.html'
                    }
                }
            })

            //Actividad - Actividad avisos
            .state('flota.ActividadAvisos', {
                url: '/actividad_avisos',
                sticky: true,
                deepStateRedirect: true,
                data: { tabTitle: 'Actividad de los avisos', tabView: 'ActividadAvisos', icon: 'icon-018' },
                views: {
                    'ActividadAvisos': {
                        controller: 'ActivityAdviceController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/actividad/actividad_avisos.html'
                    }
                }
            })

            //Órdenes
            .state('flota.ordenes', {
                url: '/ordenes',
                abstract: true,
                sticky: true,
                //deepStateRedirect: true,
                views: {
                    'ordenes': {
                        template: '<div ui-view="ordenesContainer" />'
                    }
                }
            })

            //Órdenes - Listado de órdenes
            .state('flota.ordenes.listado', {
                url: '/listado',
                data: { tabTitle: 'Órdenes de asistencia', tabView: 'ordenes', icon: 'icon-012' },
                params: { programadas: false },
                views: {
                    'ordenesContainer': {
                        controller: 'OrderListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/ordenes/listado_ordenes.html'
                    }
                }
            })

            .state('flota.ordenes_programadas', {
                url: '/ordenes_programadas',
                sticky: true,
                deepStateRedirect: true,
                data: { tabTitle: 'Órdenes Programadas', tabView: 'OrdenesProgramadas', icon: 'icon-087' },
                params: { programadas: true },
                views: {
                    'OrdenesProgramadas': {
                        controller: 'ScheduledOrdersController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/ordenes/ordenes_programadas.html'
                    }
                }
            })

            //Órdenes - Nueva orden
            .state('flota.ordenes.nueva', {
                url: '/nueva',
                data: { tabTitle: 'Nueva orden', tabView: 'ordenes', icon: 'icon-012' },
                params: { accion: 'guardarCerrar', preload: null },
                views: {
                    'ordenesContainer': {
                        controller: 'OrderFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/ordenes/form_ordenGRU.html'
                    }
                }
            })

            //Órdenes - Editar orden
            .state('flota.ordenes.editar', {
                url: '/editarOrden?id',
                data: { tabTitle: 'Editar orden', tabView: 'ordenes', icon: 'icon-012' },
                params: { allOrdersOpen: null, accion: 'guardarCerrar' },
                views: {
                    'ordenesContainer': {
                        controller: 'OrderFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/ordenes/form_ordenGRU.html'
                    }
                }
            })

            // //Logística
            // .state('flota.logistica', {
            //     url: '/logistica',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'logistica': {
            //             template: '<div ui-view="logisticaContainer"/>'
            //         }
            //     }
            // })

            // //Logística - Listado de pedidos
            // .state('flota.logistica.listado', {
            //     url: '/listado',
			// 	data: { tabTitle: 'Órdenes de traslado', tabView: 'logistica', icon: 'icon-034', isNuevas: false },
            //     views: {
            //         'logisticaContainer': {
            //             controller: 'LogisticsListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/logistica/listado_pedidos.html'
            //         }
            //     }
			// })
			
			// .state('flota.logistica.listado.nuevas', {
			// 	url: '/nuevas',
			// 	data: { tabTitle: 'Órdenes de traslado', tabView: 'logistica', icon: 'icon-034', isNuevas : true },
			// 	views: {
			// 		'logisticaContainer': {
			// 			controller: 'LogisticsListController',
			// 			controllerAs: 'vm',
			// 			templateUrl: 'app/views/flota/logistica/listado_pedidos.html'
			// 		}
			// 	}
			// })

			// .state('flota.logistica.gestion', {
			// 	url: '/gestion',
			// 	data: { tabTitle: 'Gestión de traslados', tabView: 'logistica', icon: 'icon-034' },
			// 	views: {
			// 		'logisticaContainer': {
			// 			controller: 'LogisticsManagementController',
			// 			controllerAs: 'vm',
			// 			templateUrl: 'app/views/flota/logistica/gestion_logistica.html'
			// 		}
			// 	}
			// })

            // //Logística - Nuevo pedido
            // .state('flota.logistica.nuevo', {
            //     url: '/nuevo',
            //     data: { tabTitle: 'Nueva orden de traslado', tabView: 'logistica', icon: 'icon-034' },
            //     params: { accion: 'guardarCerrar', preload: null },
            //     views: {
            //         'logisticaContainer': {
            //             controller: 'LogisticsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/logistica/form_pedido.html'
            //         }
            //     }
            // })

            // //Logística - Editar pedido
            // .state('flota.logistica.editar', {
            //     url: '/editar?id',
            //     data: { tabTitle: 'Editar orden traslado', tabView: 'logistica', icon: 'icon-034' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'logisticaContainer': {
            //             controller: 'LogisticsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/logistica/form_pedido.html'
            //         }
            //     }
            // })

            // //Planificador logistica
            // .state('flota.planificador', {
            //     url: '/planificador',
            //     data: { tabTitle: 'Planificador de órdenes', tabView: 'planificador', icon: 'icon-034' },
            //     sticky: true,
            //     deepStateRedirect: true,
            //     views: {
            //         'planificador': {
            //             controller: 'LogisticsPlannerController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/logistica/planificador_pedidos.html'
            //         }
            //     }
            // })

            // //Estancias
            // .state('flota.estancias', {
            //     url: '/estancias',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'estancias': {
            //             template: '<div ui-view="estanciasContainer"/>'
            //         }
            //     }
            // })

            // //Estancias - Listado estancias
            // .state('flota.estancias.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Gestión de estancias', tabView: 'estancias', icon: 'icon-036' },
            //     views: {
            //         'estanciasContainer': {
            //             controller: 'StaysListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/estancias/default.html'
            //         }
            //     }
            // })

            // //Estancias - Nueva estancia
            // .state('flota.estancias.nueva', {
            //     url: '/nueva',
            //     data: { tabTitle: 'Nueva estancia', tabView: 'estancias', icon: 'icon-036' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'estanciasContainer': {
            //             controller: 'StaysFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/estancias/nueva_estancia.html'
            //         }
            //     }
            // })

            // //Estancias - Editar estancia
            // .state('flota.estancias.editar', {
            //     url: '/editar?id',
            //     data: { tabTitle: 'Editar estancia', tabView: 'estancias', icon: 'icon-036' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'estanciasContainer': {
            //             controller: 'StaysFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/estancias/nueva_estancia.html'
            //         }
            //     }
            // })

            // //Recorridos
            // .state('flota.recorridos', {
            //     url: '/recorridos',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'recorridos': {
            //             template: '<div ui-view="recorridosContainer"/>'
            //         }
            //     }
            // })

            // //Recorridos - Recorrido del vehículo
            // .state('flota.recorridos.recorridos', {
            //     url: '/recorridos?flotaId&time',
            //     data: { tabTitle: 'Recorridos', tabView: 'recorridos', icon: 'icon-037' },
            //     views: {
            //         'recorridosContainer': {
            //             controller: 'TravelController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/recorridos/default.html'
            //         }
            //     }
            // })

            // //Finalizados
            // .state('flota.finalizados', {
            //     url: '/finalizados',
            //     abstract: true,
            //     sticky: true,
            //     //deepStateRedirect: true,
            //     views: {
            //         'finalizados': {
            //             template: '<div ui-view="finalizadosContainer"/>'
            //         }
            //     }
            // })

            // //Finalizados - Detalle
            // .state('flota.finalizados.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Enviar finalizados', tabView: 'finalizados', icon: 'icon-056' },
            //     params: { programadas: false },
            //     views: {
            //         'finalizadosContainer': {
            //             controller: 'FinalizadosListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/finalizados/listado_finalizados.html'
            //         }
            //     }
            // })

            // //Finalizados - Detalle
            // .state('flota.finalizados.detalle', {
            //     url: '/detalle',
            //     data: { tabTitle: 'Finalizados', tabView: 'finalizados', icon: 'icon-056' },
            //     params: { programadas: false },
            //     views: {
            //         'finalizadosContainer': {
            //             controller: 'FinalizadosDetailController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/finalizados/detalle_finalizados.html'
            //         }
            //     }
            // })


            // //Alarmas
            // .state('flota.alarmas', {
            //     url: '/alarmas',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'alarmas': {
            //             template: '<div ui-view="alarmasContainer"/>'
            //         }
            //     }
            // })



            // //Alarmas - Listado Alarmas
            // .state('flota.alarmas.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Listado de alarmas', tabView: 'alarmas', icon: 'icon-020' },
            //     views: {
            //         'alarmasContainer': {
            //             controller: 'AlarmsListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/alarmas/default.html'
            //         }
            //     }
            // })

            // //Alarmas - Nueva alarma
            // .state('flota.alarmas.nueva', {
            //     url: '/nueva',
            //     data: { tabTitle: 'Nueva alarma', tabView: 'alarmas', icon: 'icon-020' },
            //     views: {
            //         'alarmasContainer': {
            //             controller: 'AlarmsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/alarmas/nueva_alarma.html'
            //         }
            //     }
            // })

            // //Mantenimiento
            // .state('flota.mantenimiento', {
            //     url: '/mantenimiento',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'mantenimiento': {
            //             template: '<div ui-view="mantenimientoContainer"/>'
            //         }
            //     }
            // })

            // //Mantenimiento - Listado mantenimiento
            // .state('flota.mantenimiento.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Listado de mantenimiento', tabView: 'mantenimiento', icon: 'icon-021' },
            //     views: {
            //         'mantenimientoContainer': {
            //             controller: 'MaintenanceListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/mantenimiento/default.html'
            //         }
            //     }
            // })

            // //Mantenimiento - Nuevo mantenimiento
            // .state('flota.mantenimiento.nuevo', {
            //     url: '/nuevo',
            //     data: { tabTitle: 'Nuevo mantenimiento', tabView: 'mantenimiento', icon: 'icon-021' },
            //     views: {
            //         'mantenimientoContainer': {
            //             controller: 'MaintenanceFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/mantenimiento/nuevo_mantenimiento.html'
            //         }
            //     }
            // })

            // //Productos
            // .state('flota.productos', {
            //     url: '/productos',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'productos': {
            //             template: '<div ui-view="productosContainer"/>'
            //         }
            //     }
            // })

            //Clientes
            .state('flota.clientes', {
                url: '/clientes',
                sticky: true,
                abstract: true,
                views: {
                    'clientes': {
                        template: '<div ui-view="clientesContainer"/>'
                    }
                }
            })

            //Clientes - Listado de clientes
            .state('flota.clientes.listado', {
                url: '/listado',
                data: { tabTitle: 'Clientes', tabView: 'clientes', icon: 'icon-077' },
                views: {
                    'clientesContainer': {
                        controller: 'ClientsListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/clientes/default.html'
                    }
                }
            })

            //Clientes - Nuevo cliente
            .state('flota.clientes.nuevo', {
                url: '/nuevo',
                data: { tabTitle: 'Nuevo cliente', tabView: 'clientes', icon: 'icon-077' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'clientesContainer': {
                        controller: 'ClientsFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/clientes/nuevo_cliente.html'
                    }
                }
            })

            //Clientes - Editar cliente
            .state('flota.clientes.editar', {
                url: '/editar?id',
                data: { tabTitle: 'Editar cliente', tabView: 'clientes', icon: 'icon-077' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'clientesContainer': {
                        controller: 'ClientsFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/clientes/nuevo_cliente.html'
                    }
                }
            })

            // //Presupuestos
            // .state('flota.presupuestos', {
            //     url: '/presupuestos',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'presupuestos': {
            //             template: '<div ui-view="presupuestosContainer"/>'
            //         }
            //     }
            // })

            // //Presupuestos tabla
            // .state('flota.presupuestos.presupuestos', {
            //     url: '/presupuestos',
            //     data: { tabTitle: 'Presupuestos', tabView: 'presupuestos', icon: 'icon-097' },
            //     views: {
            //         'presupuestosContainer': {
            //             controller: 'budgetsController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/presupuestos/default.html'
            //         }
            //     }
            // })

            //perfilflota
            .state('flota.perfilflota', {
                url: '/perfilflota',
                sticky: true,
                abstract: true,
                views: {
                    'perfilflota': {
                        template: '<div ui-view="perfilflotaContainer"/>'
                    }
                }
            })
            //perfilflota - Listado de perfilflota
            .state('flota.perfilflota.listado', {
                url: '/listado',
                data: { tabTitle: 'Listado de perfil de flota', tabView: 'perfilflota', icon: 'icon-099' },
                views: {
                    'perfilflotaContainer': {
                        controller: 'PerfilFlotaListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/perfilflota/listado_perfilflota.html'
                    }
                }
            })

            //perfilflota - Nuevo perfilflota
            .state('flota.perfilflota.nuevo', {
                url: '/nuevo',
                data: { tabTitle: 'Nuevo perfil de flota', tabView: 'perfilflota', icon: 'icon-099' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'perfilflotaContainer': {
                        controller: 'PerfilFlotaFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/perfilflota/form_perfilflota.html'
                    }
                }
            })

            //perfilflota - Editar perfilflota
            .state('flota.perfilflota.editar', {
                url: '/editar?id',
                data: { tabTitle: 'Editar Perfil Flota', tabView: 'perfilflota', icon: 'icon-099' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'perfilflotaContainer': {
                        controller: 'PerfilFlotaFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/perfilflota/form_perfilflota.html'
                    }
                }
            })

            // //Colectivos
            // .state('flota.colectivos', {
            //     url: '/colectivos',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'colectivos': {
            //             template: '<div ui-view="colectivosContainer"/>'
            //         }
            //     }
            // })

            // //Colectivos - Listado colectivos
            // .state('flota.colectivos.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Colectivos', tabView: 'colectivos', icon: 'icon-025' },
            //     views: {
            //         'colectivosContainer': {
            //             controller: 'ColectiveListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/colectivos/default.html'
            //         }
            //     }
            // })

            // //Colectivos - Nuevo colectivo
            // .state('flota.colectivos.nuevo', {
            //     url: '/nuevo',
            //     data: { tabTitle: 'Nuevo colectivo', tabView: 'colectivos', icon: 'icon-025' },
            //     views: {
            //         'colectivosContainer': {
            //             controller: 'ColectiveFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/colectivos/nuevo_colectivo.html'
            //         }
            //     }
            // })

            //Vehículos
            .state('flota.vehiculos', {
                url: '/vehiculos',
                sticky: true,
                abstract: true,
                views: {
                    'vehiculos': {
                        template: '<div ui-view="vehiculosContainer"/>'
                    }
                }
            })

            //Vehículos - Listado de vehículos
            .state('flota.vehiculos.listado', {
                url: '/listado',
                data: { tabTitle: 'Vehículos', tabView: 'vehiculos', icon: 'icon-076' },
                views: {
                    'vehiculosContainer': {
                        controller: 'VehiclesListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/vehiculos/default.html'
                    }
                }
            })

            //Vehículos - Nuevo vehículo
            .state('flota.vehiculos.nuevo', {
                url: '/nuevo',
                data: { tabTitle: 'Nuevo vehículo', tabView: 'vehiculos', icon: 'icon-076' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'vehiculosContainer': {
                        controller: 'VehiclesFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/vehiculos/nuevo_vehiculo.html'
                    }
                }
            })

            //Vehiculos - Editar vehiculo
            .state('flota.vehiculos.editar', {
                url: '/editar?id',
                data: { tabTitle: 'Editar vehículo', tabView: 'vehiculos', icon: 'icon-076' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'vehiculosContainer': {
                        controller: 'VehiclesFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/vehiculos/nuevo_vehiculo.html'
                    }
                }
            })

           
            // //Colaboradores
            // .state('flota.colaboradores', {
            //     url: '/colaboradores',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'colaboradores': {
            //             template: '<div ui-view="colaboradoresContainer"/>'
            //         }
            //     }
            // })

            // //Colaboradores - Listado colaboradores
            // .state('flota.colaboradores.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Colaboradores', tabView: 'colaboradores', icon: 'icon-025' },
            //     views: {
            //         'colaboradoresContainer': {
            //             controller: 'PartnerListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/colaboradores/default.html'
            //         }
            //     }
            // })

            // //Colaboradores - Nuevo colaborador
            // .state('flota.colaboradores.nuevo', {
            //     url: '/nuevo',
            //     data: { tabTitle: 'Nuevo colaborador', tabView: 'colaboradores', icon: 'icon-025' },
            //     views: {
            //         'colaboradoresContainer': {
            //             controller: 'PartnerFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/colaboradores/nuevo_colaborador.html'
            //         }
            //     }
            // })

            //Chóferes
            .state('flota.choferes', {
                url: '/choferes',
                sticky: true,
                abstract: true,
                views: {
                    'choferes': {
                        template: '<div ui-view="choferesContainer"/>'
                    }
                }
            })

            //Chóferes - Listado de chóferes
            .state('flota.choferes.listado', {
                url: '/listado',
                data: { tabTitle: 'Chóferes', tabView: 'choferes', icon: 'icon-009' },
                views: {
                    'choferesContainer': {
                        controller: 'DriverListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/choferes/default.html'
                    }
                }
            })

            //Chóferes - Nuevo chofer
            .state('flota.choferes.nuevo', {
                url: '/nuevo',
                data: { tabTitle: 'Nuevo chofer', tabView: 'choferes', icon: 'icon-009' },
                params: { accion: 'guardarCerrar' },
                views: {
                    'choferesContainer': {
                        controller: 'DriverFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/choferes/nuevo_chofer.html'
                    }
                }
            })

            //Chóferes - Editar chofer
            .state('flota.choferes.editar', {
                url: '/editar?id',
                data: { tabTitle: 'Editar chofer', tabView: 'choferes', icon: 'icon-009' },
                params: { accion: 'guardarCerrar' },                
                views: {
                    'choferesContainer': {
                        controller: 'DriverFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/choferes/nuevo_chofer.html'
                    }
                }
            })

            // //Zonas
            // .state('flota.zonas', {
            //     url: '/zonas',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'zonas': {
            //             template: '<div ui-view="zonasContainer"/>'
            //         }
            //     }
            // })

            // //Zonas - Listado zonas
            // .state('flota.zonas.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Listado de zonas', tabView: 'zonas', icon: 'icon-025' },
            //     views: {
            //         'zonasContainer': {
            //             controller: 'ZoneListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/zonas/default.html'
            //         }
            //     }
            // })

            // //Zonas - Nueva zona
            // .state('flota.zonas.nueva', {
            //     url: '/nueva',
            //     data: { tabTitle: 'Nueva Zona', tabView: 'zonas', icon: 'icon-025' },
            //     views: {
            //         'zonasContainer': {
            //             controller: 'ZoneFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/zonas/nueva_zona.html'
            //         }
            //     }
            // })

            // //Puntos de interés
            // .state('flota.puntosInteres', {
            //     url: '/puntos_interes',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'puntos': {
            //             template: '<div ui-view="puntosContainer"/>'
            //         }
            //     }
            // })

            // //Puntos de interés - Listado puntos de interés
            // .state('flota.puntosInteres.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Puntos de interés', tabView: 'puntos', icon: 'icon-025' },
            //     views: {
            //         'puntosContainer': {
            //             controller: 'PointsListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/puntos/default.html'
            //         }
            //     }
            // })

            // //Puntos de interés - Nuevo punto de interés
            // .state('flota.puntosInteres.nuevo', {
            //     url: '/nuevo',
            //     data: { tabTitle: 'Nuevo punto de interés', tabView: 'puntos', icon: 'icon-025' },
            //     views: {
            //         'puntosContainer': {
            //             controller: 'PointsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/puntos/nuevo_punto.html'
            //         }
            //     }
            // })

            // //Empresas
            // .state('flota.empresas', {
            //     url: '/empresas',
            //     sticky: true,
            //     abstract: true,
            //     views: {
            //         'empresas': {
            //             template: '<div ui-view="empresasContainer"/>'
            //         }
            //     }
            // })

            // //Empresas - Listado empresas
            // .state('flota.empresas.listado', {
            //     url: '/listado',
            //     data: { tabTitle: 'Empresas', tabView: 'empresas', icon: 'icon-025' },
            //     views: {
            //         'empresasContainer': {
            //             controller: 'BusinessListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/empresas/default.html'
            //         }
            //     }
            // })

            // //Empresas - Nueva empresa
            // .state('flota.empresas.nueva', {
            //     url: '/nueva',
            //     data: { tabTitle: 'Nueva empresa', tabView: 'empresas', icon: 'icon-025' },
            //     views: {
            //         'empresasContainer': {
            //             controller: 'BusinessFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/empresas/nueva_empresa.html'
            //         }
            //     }
            // })

            // //Chat
            // .state('flota.chat', {
            //     url: '/chat?id',
            //     sticky: true,
            //     deepStateRedirect: true,
            //     data: { tabTitle: 'Chat', tabView: 'flotaChat', icon: 'icon-005' },
            //     views: {
            //         'flotaChat': {
            //             controller: 'ChatController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/chat/default.html'
            //         }
            //     }
            // })

            

            //Configuracion
            .state('flota.configuracion', {
                url: '/configuracion',
                sticky: true,
                abstract: true,
                views: {
                    'configuracion': {
                        template: '<div ui-view="configuracionContainer"/>'
                    }
                }
            })

            // //Configuracion general
            // .state('flota.configuracion.general', {
            //     url: '/general',
            //     data: { tabTitle: 'Configuración general', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'GeneralConfigController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/default.html'
            //         }
            //     }
            // })

            // //Talleres - Listado talleres
            // .state('flota.configuracion.listadoTalleres', {
            //     url: '/talleres',
            //     data: { tabTitle: 'Talleres', tabView: 'configuracion', icon: 'icon-025' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'WorkshopListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/talleres/default.html'
            //         }
            //     }
            // })

            // //Talleres - Nuevo taller
            // .state('flota.configuracion.nuevoTaller', {
            //     url: '/nuevoTaller',
            //     data: { tabTitle: 'Nuevo taller', tabView: 'configuracion', icon: 'icon-025' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'WorkshopFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/talleres/nuevo_taller.html'
            //         }
            //     }
            // })

            // //Configuracion - Talleres - Editar taller
            // .state('flota.configuracion.editarTaller', {
            //     url: '/editarTaller?id',
            //     data: { tabTitle: 'Editar taller', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'WorkshopFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/talleres/nuevo_taller.html'
            //         }
            //     }
            // })

            // //Configuracion: Averías
            // .state('flota.configuracion.listadoAverias', {
            //     url: '/averias',
            //     data: { tabTitle: 'Averías', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'DamageListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/averias/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Averías - Nueva avería
            // .state('flota.configuracion.nuevaAveria', {
            //     url: '/nuevaAveria',
            //     data: { tabTitle: 'Nueva averia', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'DamageFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/averias/nueva_averia.html'
            //         }
            //     }
            // })

            // //Configuracion: Averías - Editar avería
            // .state('flota.configuracion.editarAveria', {
            //     url: '/editarAveria?id',
            //     data: { tabTitle: 'Editar averia', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'DamageFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/averias/nueva_averia.html'
            //         }
            //     }
            // })

            // //Configuracion: Colores
            // .state('flota.configuracion.listadoColores', {
            //     url: '/colores',
            //     data: { tabTitle: 'Colores', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ColorsListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/colores/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Colores - Nuevo color
            // .state('flota.configuracion.nuevoColor', {
            //     url: '/nuevoColor',
            //     data: { tabTitle: 'Nuevo color', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar', preload: null },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ColorFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/colores/nuevo_color.html'
            //         }
            //     }
            // })

            // //Configuracion - Colores - Editar color
            // .state('flota.configuracion.editarColor', {
            //     url: '/editarColor?id',
            //     data: { tabTitle: 'Editar color', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ColorFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/colores/nuevo_color.html'
            //         }
            //     }
            // })

            // //Configuracion: Contadores
            // .state('flota.configuracion.listadoContadores', {
            //     url: '/contadores',
            //     data: { tabTitle: 'Contadores', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'CounterListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/contadores/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Contadores - Nuevo contador
            // .state('flota.configuracion.nuevoContador', {
            //     url: '/nuevoContador',
            //     data: { tabTitle: 'Nuevo contador', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'CounterFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/contadores/nuevo_contador.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado de estados de operario
            // .state('flota.configuracion.listadoEstadosOperario', {
            //     url: '/listadoEstadosOperario',
            //     data: { tabTitle: 'Estados de operario', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'StateListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/estados/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado de estados de operario - Nuevo estado de operario
            // .state('flota.configuracion.nuevoEstado', {
            //     url: '/nuevoEstado',
            //     data: { tabTitle: 'Nuevo estado de operario', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'StateFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/estados/nuevo_estado.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado de estados de operario - Editar estado de operario
            // .state('flota.configuracion.editarEstado', {
            //     url: '/editarEstado?id',
            //     data: { tabTitle: 'Editar estado de operario', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'StateFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/estados/nuevo_estado.html'
            //         }
            //     }
            // })

            // //Grupos - Listado grupos
            // .state('flota.configuracion.listadoGrupos', {
            //     url: '/grupos',
            //     data: { tabTitle: 'Grupos', tabView: 'configuracion', icon: 'icon-025' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'GroupsListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/grupos/default.html'
            //         }
            //     }
            // })

            // //Grupos - Nuevo grupo
            // .state('flota.configuracion.nuevoGrupo', {
            //     url: '/nuevoGrupo',
            //     data: { tabTitle: 'Nuevo grupo', tabView: 'configuracion', icon: 'icon-025' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'GroupsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/grupos/nuevo_grupo.html'
            //         }
            //     }
            // })

            // //Configuracion - Grupos - Editar grupo
            // .state('flota.configuracion.editarGrupo', {
            //     url: '/editarGrupo?id',
            //     data: { tabTitle: 'Editar grupo', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'GroupsFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/grupos/nuevo_grupo.html'
            //         }
            //     }
            // })


            // //Configuracion: Tipos de mantenimiento
            // .state('flota.configuracion.tiposMantenimientos', {
            //     url: '/tiposMantenimientos',
            //     data: { tabTitle: 'Tipos de mantenimiento', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MaintenanceTypeListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mantenimiento/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Tipos de mantenimiento - Nuevo tipo de mantenimiento
            // .state('flota.configuracion.nuevoTipoMantenimiento', {
            //     url: '/nuevoTipoMantenimiento',
            //     data: { tabTitle: 'Nuevo tipo de mantenimiento', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MaintenanceTypeFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mantenimiento/nuevo_tipo_mantenimiento.html'
            //         }
            //     }
            // })

            // //Configuracion - Tipos de mantenimiento - Editar Tipo de mantenimiento
            // .state('flota.configuracion.editarTipoMantenimiento', {
            //     url: '/editarTipoMantenimiento?id',
            //     data: { tabTitle: 'Editar tipo mantenimiento', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MaintenanceTypeFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mantenimiento/nuevo_tipo_mantenimiento.html'
            //         }
            //     }
            // })

            // //Configuracion: Marcas
            // .state('flota.configuracion.listadoMarcas', {
            //     url: '/marcas',
            //     data: { tabTitle: 'Marcas', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'BrandListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/marcas/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Marcas - Nueva marca
            // .state('flota.configuracion.nuevaMarca', {
            //     url: '/nuevaMarca',
            //     data: { tabTitle: 'Nueva marca', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'BrandFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/marcas/nueva_marca.html'
            //         }
            //     }
            // })


            // //Configuracion: Base
            // .state('flota.configuracion.listadoBases', {
            //     url: '/bases',
            //     data: { tabTitle: 'Bases', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'BaseListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/bases/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Base - Nueva Base
            // .state('flota.configuracion.nuevaBase', {
            //     url: '/nuevaBase',
            //     data: { tabTitle: 'Nueva base', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'BaseFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/bases/nueva_base.html'
            //         }
            //     }
            // })

            // //Configuracion: Base - Editar Base
            // .state('flota.configuracion.editarBase', {
            //     url: '/editarBase?id',
            //     data: { tabTitle: 'Editar Base', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'BaseFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/bases/nueva_base.html'
            //         }
            //     }
            // })

            // //Configuracion: Productos - Listado productos
            // .state('flota.configuracion.listadoproductos', {
            //     url: '/productos',
            //     data: { tabTitle: 'Listado de productos', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ProductoListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/productos/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Productos - Nuevo productos
            // .state('flota.configuracion.nuevoProducto', {
            //     url: '/nuevoProducto',
            //     data: { tabTitle: 'Nuevo producto', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ProductoFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/productos/nuevo_producto.html'
            //         }
            //     }
            // })

            // //Configuracion: Productos - Nuevo productos
            // .state('flota.configuracion.editarProducto', {
            //     url: '/editarProducto?id',
            //     data: { tabTitle: 'Editar producto', tabView: 'configuracion', icon: 'icon-019' },
            //     params: { accion: 'guardarCerrar' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ProductoFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/productos/nuevo_producto.html'
            //         }
            //     }
            // })

            // //Configuracion: Mensajes predefinidos de chat
            // .state('flota.configuracion.listadoMensajes', {
            //     url: '/listadoMensajes',
            //     data: { tabTitle: 'Mensajes predefinidos', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MessageListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mensajes/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Mensajes predefinidos de chat - Nuevo mensaje predefinido de chat
            // .state('flota.configuracion.nuevoMensaje', {
            //     url: '/nuevoMensaje',
            //     data: { tabTitle: 'Nuevo mensaje predefinido', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MessageFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mensajes/nuevo_mensaje.html'
            //         }
            //     }
            // })

            // //Configuracion: Mensajes predefinidos de chat - Editar mensaje predefinido de chat
            // .state('flota.configuracion.editarMensaje', {
            //     url: '/editarMensaje?id',
            //     data: { tabTitle: 'Editar mensaje predefinido', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'MessageFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/mensajes/nuevo_mensaje.html'
            //         }
            //     }
            // })

            // //Configuracion: Modelo
            // .state('flota.configuracion.listadoModelos', {
            //     url: '/modelos',
            //     data: { tabTitle: 'Modelos', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ModelListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/modelos/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Modelo - Nuevo modelo
            // .state('flota.configuracion.nuevoModelo', {
            //     url: '/nuevoModelo',
            //     data: { tabTitle: 'Nuevo modelo', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'ModelFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/modelos/nuevo_modelo.html'
            //         }
            //     }
            // })

            // //Configuracion: Roles
            // .state('flota.configuracion.listadoRoles', {
            //     url: '/roles',
            //     data: { tabTitle: 'Roles', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'RoleListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/roles/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Roles - Nuevo rol
            // .state('flota.configuracion.nuevoRol', {
            //     url: '/nuevoRol',
            //     data: { tabTitle: 'Nuevo rol', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'RoleFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/roles/nuevo_rol.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado tipos
            // .state('flota.configuracion.listadoTipoOrden', {
            //     url: '/tipoOrden',
            //     data: { tabTitle: 'Listado de tipos de órdenes', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'OrderTypeListController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/tipos/default.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado tipos - Nuevo tipo de orden
            // .state('flota.configuracion.nuevoTipoOrden', {
            //     url: '/nuevoTipoOrden',
            //     data: { tabTitle: 'Nuevo tipo de orden', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'OrderTypeFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/tipos/nuevo_tipo.html'
            //         }
            //     }
            // })

            // //Configuracion: Listado tipos - Editar tipo de orden
            // .state('flota.configuracion.editarTipoOrden', {
            //     url: '/editarTipoOrden?id',
            //     data: { tabTitle: 'Editar tipo de orden', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'OrderTypeFormController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/tipos/nuevo_tipo.html'
            //         }
            //     }
            // })

            //Configuracion: Usuarios
            .state('flota.configuracion.listadoUsuarios', {
                url: '/listadoUsuarios',
                data: { tabTitle: 'Usuarios', tabView: 'configuracion', icon: 'icon-019' },
                views: {
                    'configuracionContainer': {
                        controller: 'UserListController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/configuracion/usuarios/default.html'
                    }
                }
            })

            //Configuracion: Usuarios - Nuevo usuario
            .state('flota.configuracion.nuevoUsuario', {
                url: '/nuevoUsuario',
                data: { tabTitle: 'Nuevo usuario', tabView: 'configuracion', icon: 'icon-019' },
                views: {
                    'configuracionContainer': {
                        controller: 'UserFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/configuracion/usuarios/nuevo_usuario.html'
                    }
                }
            })

            //Chóferes - Editar usuario
            .state('flota.configuracion.editarUsuario', {
                url: '/editarUsuario?id',
                data: { tabTitle: 'Editar usuario', tabView: 'configuracion', icon: 'icon-019' },
                views: {
                    'configuracionContainer': {
                        controller: 'UserFormController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/configuracion/usuarios/nuevo_usuario.html'
                    }
                }
            })

            // //Configuracion: Asignación de alarmas
            // .state('flota.configuracion.asignacion', {
            //     url: '/alarmas',
            //     data: { tabTitle: 'Asignación de alarmas', tabView: 'configuracion', icon: 'icon-019' },
            //     views: {
            //         'configuracionContainer': {
            //             controller: 'AlarmsAsignController',
            //             controllerAs: 'vm',
            //             templateUrl: 'app/views/flota/configuracion/alarmas/default.html'
            //         }
            //     }
            // })

            // Search
            .state('flota.search', {
                url: '/search',
                abstract: true,
                sticky: true,
                //deepStateRedirect: true,
                views: {
                    'search': {
                        template: '<div ui-view="searchContainer"/>'
                    }
                }
            })
            .state('flota.search.results', {
                url: '/results',
                data: { tabTitle: 'Resultados', tabView: 'search', icon: 'icon-056' },
                params: { q: '' },
                views: {
                    'searchContainer': {
                        controller: 'SearchController',
                        controllerAs: 'vm',
                        templateUrl: 'app/views/flota/search/default.html'
                    }
                }
            })



        //$urlRouterProvider.deferIntercept(); //Needed to preload the fixed states

        $httpProvider.interceptors.push('httpInterceptor');

        $urlRouterProvider
            .when('', 'flota/misfichajes')
            .when('/flota', 'flota/misfichajes');

        // $urlRouterProvider
        //     .when('', '/flota/mapa')
        //     .when('/flota', '/flota/mapa');

        $urlRouterProvider.otherwise('/flota/404');

    }
})();
